import { render, staticRenderFns } from "./ResetPasswordLog.vue?vue&type=template&id=00c0a6fa&scoped=true&"
import script from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0a6fa",
  null
  
)

export default component.exports